module.exports = __webpack_public_path__ + "static/media/simplonbp-regular-webfont.fe842061.svg";